import { callApi, makeApiRequest } from "./ApiService";
import axios from "axios";
import {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
} from "./Urls";

let getRecords = async (
  tabID,
  pageSize,
  filters = "{}",
  index = 1,

  searchVal = "",

  onComplete
) => {
  const url = `${BaseUrl}/api/CommonAPIs/GetRecords?tabErpID=${tabID}&tabName=Property%20Type`;

  const jsonBody = {
    pgSize: pageSize,
    viewFormat: "columnname",
    filterButtons: "",
    index: index,
    toEmailID: "admin@dialerp.com",
    tabErpID: tabID,
    useAtlusSearch: false,
    RoleID: 0,
    LedgerID: LoggedInUserID,
    order: -1,
    orderBy: "",
    processID: 1,
    filters: filters,
  };

  const authKey = Authorization_Token == "" ? staticToken : Authorization_Token;

 // console.log("get records req", jsonBody);

  callApi(
    url,
    jsonBody,
    authKey,
    (response) => {
      try {
        const data =
          typeof response === "string" ? JSON.parse(response) : response;

       // console.log("user details res --", data);

        if (data?.hasErrors === false) {
          onComplete(data);
        } else {
          onComplete(data); // backend returned error object
        }
      } catch (err) {
        console.error("JSON Parse Error", err);
        onComplete(null);
      }
    },
    (error) => {
      console.error("API Error", error.message || "Unknown Error");
      onComplete(null);
    }
  );
};


let PostRecords = async (
  tabID,
  pageSize,
  jsonBody ,
 

  onComplete
) => {
  const url = `${BaseUrl}/api/CommonAPIs/AddUpdateRecords?tabErpID=${tabID}`;



  const authKey = Authorization_Token == "" ? staticToken : Authorization_Token;

 // console.log("get records req", jsonBody);

  callApi(
    url,
    jsonBody,
    authKey,
    (response) => {
      try {
        const data =
          typeof response === "string" ? JSON.parse(response) : response;

        console.log("user details res --", data);

        if (data?.hasErrors === false) {
          onComplete(data);
        } else {
          onComplete(data); // backend returned error object
        }
      } catch (err) {
        console.error("JSON Parse Error", err);
        onComplete(null);
      }
    },
    (error) => {
      console.error("API Error", error.message || "Unknown Error");
      onComplete(null);
    }
  );
};

export { getRecords,PostRecords };
